import { ErrorBoundaryFallbackView } from '@/components/template/error-boundary';
import { GlobalLoadingOverlay } from '@/components/ui';
import { WebAlertHost } from '@/components/ui/alert-web-dialog';
import { AuthStateEffect } from '@/libs/firebase/auth';
import { startNetworkStatusListener } from '@/libs/network';
import { allowRestart } from '@/libs/revopush';
import { applyRevoPushSentryContext, sentryConfig } from '@/libs/sentry';
import { RootNavigator } from '@/navigations';
import { ComposeProviders, provider, QueryProvider } from '@/providers';
import { getFirestore } from '@react-native-firebase/firestore';
import * as Sentry from '@sentry/react-native';
import { useEffect, useState } from 'react';
import { Platform, StatusBar } from 'react-native';
import { KeyboardProvider } from 'react-native-keyboard-controller';
import { SafeAreaProvider } from 'react-native-safe-area-context';

Sentry.init(sentryConfig);
applyRevoPushSentryContext();

if (Platform.OS === 'android' || Platform.OS === 'ios') {
  allowRestart();
  getFirestore().settings({
    persistence: false,
  });
}

function App() {
  const [initStatusBar, setInitStatusBar] = useState(false);

  useEffect(() => startNetworkStatusListener(), []);

  return (
    <ComposeProviders
      providers={[provider(SafeAreaProvider), provider(KeyboardProvider), provider(QueryProvider)]}>
      {initStatusBar && (
        <StatusBar barStyle={'dark-content'} translucent backgroundColor="transparent" />
      )}
      <RootNavigator onReady={() => setInitStatusBar(true)} />
      <AuthStateEffect />
      <GlobalLoadingOverlay />
      <WebAlertHost />
    </ComposeProviders>
  );
}

export default Sentry.wrap(
  Sentry.withErrorBoundary(App, {
    fallback: <ErrorBoundaryFallbackView />,
  }),
);
